import { render, staticRenderFns } from "./InstructorsList.vue?vue&type=template&id=587107fa&scoped=true"
import script from "./InstructorsList.vue?vue&type=script&lang=ts"
export * from "./InstructorsList.vue?vue&type=script&lang=ts"
import style0 from "./InstructorsList.vue?vue&type=style&index=0&id=587107fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587107fa",
  null
  
)

export default component.exports